var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1818 25.8182H25.8182M20 20V25.8182M11.2727 11.2727V9.81818C11.2727 5.45455 13.4545 4 17.0909 4H22.9091C26.5455 4 28.7273 6.18182 28.7273 9.81818V11.2727C33.0909 11.2727 36 14.1818 36 18.5455C36 22.9091 33.0909 25.8182 28.7273 25.8182M11.2727 11.2727H22.9091M11.2727 11.2727C6.90909 11.2727 4 13.4545 4 18.5455C4 23.6364 6.90909 25.8182 11.2727 25.8182M14.1818 36H25.8182V20H14.1818V36Z",
    stroke: "black",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwad);
export default __webpack_public_path__ + "static/media/swad.fde0e077abb82386cf68b9a7977d4baa.svg";
export { ForwardRef as ReactComponent };